var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import render from 'utils/render';
const Svg25Years = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const Element = render.element(/*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 67",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5127 12.5314C34.9276 16.5008 28.4396 25.3695 25.8958 28.7221V29.6042C25.8958 30.0452 26.2451 30.4415 26.7278 30.4415H44.2644C44.7026 30.4415 45.0964 30.0452 45.0964 29.6042V25.6348C45.0964 25.1938 44.7026 24.7975 44.2644 24.7975H36.5473C37.1042 24.0108 37.7731 23.092 38.4805 22.1204L38.4808 22.1199C40.3913 19.4957 42.5827 16.4857 43.607 14.6503C44.6582 12.5761 45.3156 11.253 45.3156 8.91354C45.3156 4.01413 41.6317 0 35.3627 0C30.1449 0 26.5944 4.32414 26.5944 4.32414C26.2896 4.67889 26.3308 5.20622 26.6389 5.47149L29.3129 8.20723C29.6654 8.56198 30.1926 8.56198 30.5419 8.20723C31.374 7.2804 32.9968 6.00202 34.7943 6.00202C37.2491 6.00202 38.6528 7.50092 38.6528 9.1788C38.6528 10.4124 38.0812 11.6493 37.5127 12.5314Z",
    fill: "url(#paint0_linear_5670_47926)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1928 13.1513C84.1928 13.1513 81.3378 6.10099 87.5655 0.0957724C87.5655 0.0957724 91.7162 8.19114 84.1928 13.1513Z",
    fill: "url(#paint1_linear_5670_47926)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8789 24.2509C85.8789 24.2509 84.0623 14.0686 92.3638 9.89144C92.3638 9.89144 95.476 19.0287 85.8789 24.2509Z",
    fill: "url(#paint2_linear_5670_47926)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8051 33.909C83.8051 33.909 85.882 23.7267 96 23.2025C96 23.2025 93.923 33.6469 83.8051 33.909Z",
    fill: "url(#paint3_linear_5670_47926)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6513 44.6156C79.6513 44.6156 82.2459 34.9542 93.4024 36.5202C93.4024 36.5202 90.5474 45.1366 79.6513 44.6156Z",
    fill: "url(#paint4_linear_5670_47926)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8677 54.0148C71.8677 54.0148 73.9447 45.6606 87.1749 48.0096C87.1749 48.0096 84.0627 56.6259 71.8677 54.0148Z",
    fill: "url(#paint5_linear_5670_47926)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.489 59.7612C61.489 59.7612 69.7619 52.4488 78.2094 59.7612C78.2094 59.7612 69.0156 66.8115 61.489 59.7612Z",
    fill: "url(#paint6_linear_5670_47926)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8046 13.1513C11.8046 13.1513 14.6596 6.10423 8.43189 0.0990155C8.43189 0.0990155 4.28117 8.19439 11.8046 13.1545V13.1513Z",
    fill: "url(#paint7_linear_5670_47926)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1178 24.2509C10.1178 24.2509 11.9343 14.0686 3.63288 9.89144C3.63288 9.89144 0.520632 19.0287 10.1178 24.2509Z",
    fill: "url(#paint8_linear_5670_47926)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1949 33.9091C12.1949 33.9091 10.118 23.7267 0 23.2058C0 23.2058 2.07695 33.6502 12.1949 33.9123V33.9091Z",
    fill: "url(#paint9_linear_5670_47926)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3456 44.6156C16.3456 44.6156 13.751 34.9542 2.59454 36.5202C2.59454 36.5202 5.44955 45.1366 16.3456 44.6156Z",
    fill: "url(#paint10_linear_5670_47926)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1297 54.0148C24.1297 54.0148 22.0527 45.6606 8.82248 48.0096C8.82248 48.0096 11.9347 56.6259 24.1297 54.0148Z",
    fill: "url(#paint11_linear_5670_47926)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5077 59.7612C34.5077 59.7612 26.2349 52.4488 17.7873 59.7612C17.7873 59.7612 26.9812 66.8115 34.5077 59.7612Z",
    fill: "url(#paint12_linear_5670_47926)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6659 57.9075C48.9418 57.8979 48.2622 58.4636 48.0018 58.7065C47.7414 58.4636 47.0618 57.8947 46.3377 57.9075C44.6404 57.9411 42.7386 59.4444 41.286 60.5925C40.3931 61.2982 39.6698 61.8699 39.2684 61.8833C39.2684 61.8833 41.898 67 47.8652 67C53.8325 67 56.7351 61.8833 56.7351 61.8833C56.3917 61.8559 55.7576 61.3468 54.954 60.7014C53.5062 59.5389 51.5079 57.9342 49.6659 57.9075ZM47.9129 64.0629C47.4905 63.2543 45.747 62.5704 44.3528 62.3307C45.7152 62.3179 47.4873 61.8289 47.9129 61.0683C48.3384 61.8289 50.1105 62.3179 51.4729 62.3307C50.0819 62.5704 48.3352 63.2543 47.9129 64.0629Z",
    fill: "url(#paint13_linear_5670_47926)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.505 25.7211L53.268 22.9854C53.5315 22.7201 53.9698 22.6338 54.3191 22.8544C54.3191 22.8544 57.4314 24.9733 59.5369 24.9733C61.9029 24.9733 63.7003 23.2091 63.7003 20.7834C63.7003 18.3576 62.0331 16.504 59.1844 16.504H52.4327C51.5562 16.504 51.0735 15.6666 51.0735 14.9603V1.27841C51.0735 0.837369 51.4228 0.44107 51.9056 0.44107H66.0218C66.5045 0.44107 66.8539 0.837369 66.8539 1.27841V5.1615C66.8539 5.60255 66.5045 5.99885 66.0218 5.99885H56.9899V10.7193H60.1022C66.152 10.7193 70.0963 14.9987 70.0963 20.777C70.0963 26.5553 65.4057 30.8794 59.267 30.8794C54.7066 30.8794 51.6832 28.54 50.5876 27.2168C50.0191 26.5553 49.9747 26.2453 50.4987 25.7179L50.505 25.7211Z",
    fill: "url(#paint14_linear_5670_47926)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0547 37.1784L29.0114 41.6719H29.0019V45.9513C29.0019 46.0855 29.1098 46.207 29.2559 46.207H30.847C30.9804 46.207 31.101 46.0855 31.101 45.9513V41.6591L34.0958 37.1784C34.2038 37.0026 34.0958 36.7885 33.883 36.7885H32.1459C32.0254 36.7885 31.9745 36.8554 31.9333 36.9096L30.0753 39.668L28.2174 36.9099C28.1793 36.8556 28.1126 36.7885 28.0047 36.7885H26.2675C26.0547 36.7885 25.9468 37.0026 26.0547 37.1784Z",
    fill: "url(#paint15_linear_5670_47926)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9915 37.0409C35.9915 36.9067 36.0994 36.7852 36.2455 36.7852H41.7809C41.927 36.7852 42.0349 36.9067 42.0349 37.0409V38.5078C42.0349 38.6421 41.927 38.7635 41.7809 38.7635H38.0779V40.4318H41.1267C41.26 40.4318 41.3807 40.5532 41.3807 40.6875V42.1544C41.3807 42.3014 41.26 42.4101 41.1267 42.4101H38.0779V44.2286H41.7809C41.927 44.2286 42.0349 44.3501 42.0349 44.4843V45.9512C42.0349 46.0855 41.927 46.2069 41.7809 46.2069H36.2455C36.0994 46.2069 35.9915 46.0855 35.9915 45.9512V37.0409Z",
    fill: "url(#paint16_linear_5670_47926)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8785 36.7981L43.6929 45.8554C43.6135 46.0312 43.7215 46.207 43.9215 46.207H45.3919C45.6618 46.207 45.8079 46.044 45.8746 45.8842L46.3573 44.8072H49.9936L50.4763 45.8714C50.597 46.1271 50.7018 46.207 50.9432 46.207H52.4262C52.6295 46.207 52.7343 46.0312 52.6549 45.8554L48.4692 36.7981C48.4279 36.7182 48.3358 36.6511 48.2406 36.6511H48.1072C48.0119 36.6511 47.9198 36.7182 47.8785 36.7981ZM48.1707 40.7547L49.187 42.9759H47.1545L48.158 40.7547H48.1707Z",
    fill: "url(#paint17_linear_5670_47926)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5382 37.0409C54.5382 36.9067 54.6461 36.7852 54.7922 36.7852H58.7905C60.3943 36.7852 61.7059 38.0892 61.7059 39.6935C61.7059 40.9304 60.8897 41.9275 59.7274 42.3973L61.5598 45.817C61.6551 45.9928 61.5598 46.2069 61.3311 46.2069H59.5527C59.4447 46.2069 59.3653 46.1398 59.3399 46.0855L57.5615 42.5188H56.6373V45.9512C56.6373 46.0855 56.5167 46.2069 56.3833 46.2069H54.7922C54.6461 46.2069 54.5382 46.0855 54.5382 45.9512V37.0409ZM58.6159 40.8089C59.1653 40.8089 59.6321 40.2976 59.6321 39.7319C59.6321 39.1662 59.1653 38.7092 58.6159 38.7092H56.6373V40.8089H58.6159Z",
    fill: "url(#paint18_linear_5670_47926)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3831 43.81L63.7543 44.9286H63.7575C63.6495 45.1172 63.6908 45.1715 63.8242 45.3057C64.129 45.6157 65.0945 46.3412 66.8316 46.3412C68.7974 46.3412 69.9883 44.9414 69.9883 43.5543C69.9883 41.7231 68.3274 40.9049 67.2857 40.4862C66.2282 40.058 65.8281 39.6808 65.8281 39.1823C65.8281 38.8179 66.1869 38.4951 66.6696 38.4951C67.3737 38.4951 68.196 39.047 68.4861 39.2416C68.5322 39.2726 68.5649 39.2945 68.5815 39.3037C68.7021 39.3964 68.9435 39.2749 69.0356 39.1279L69.7184 38.0924C69.7724 37.9966 69.8009 37.7537 69.639 37.661C69.2388 37.3638 68.1686 36.6511 66.7776 36.6511C64.7166 36.6511 63.6876 37.9966 63.6876 39.3293C63.6876 40.9464 65.1326 41.8477 66.2822 42.3047C67.1936 42.6659 67.6605 43.0973 67.6605 43.663C67.6605 44.136 67.2699 44.4716 66.7363 44.4716C65.9566 44.4716 65.115 43.9132 64.8918 43.7651C64.8623 43.7455 64.8435 43.7331 64.8372 43.7301C64.7451 43.663 64.4911 43.6342 64.3831 43.81Z",
    fill: "url(#paint19_linear_5670_47926)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5670_47926",
    x1: 0.0000031272,
    y1: 67,
    x2: 50.1945,
    y2: -24.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CE5A"
  }))))));
  return /*#__PURE__*/React.createElement(Element.type, _extends({}, Element.props, {
    ref: ref
  }), children, Element.props.children);
});
export default /*#__PURE__*/React.memo(Svg25Years);